module.exports = __webpack_public_path__ + "img/gleichstreckenlast.ab302d5c.jpg";